import { Chip, Stack } from "@mui/material";
import React from "react";

export const DaysAvailability = ({ availability = null }) => {
  if (!availability || typeof availability !== "object") {
    return null;
  }

  const keys = Object.keys(availability);

  return (
    <Stack direction={"row"} spacing={1}>
      {keys.map((key, index) => (
        <Chip
          key={index}
          label={key.charAt(0).toUpperCase()}
          color={availability[key] ? "primary" : "default"}
          size="medium"
          sx={{
            "& .MuiChip-label": {
              textOverflow: "clip",
              textTransform: "capitalize",
              width: "30px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
          }}
        />
      ))}
    </Stack>
  );
};

export default DaysAvailability;

// Usage of prop `availability`:
// { "monday": false, "tuesday": false, "wednesday": false, "thursday": false, "friday": false, "saturday": false, "sunday": false }
